import { ChangeEvent, useCallback, useState } from 'react'
import { useAppContext } from '../../hooks/useAppContext'
import styles from './Charts.module.scss'
import queryString from 'query-string'
import { NumericFormat } from 'react-number-format'
import { getTableValues } from '../../context/utils'

export const Impact = () => {
    const [btnText, setBtnText] = useState('Share results')
    const { tableValues, monthsForChart, setmonthsForChart, chartsValues, currentWebsiteFormData, newWebsiteFormData, investmentFormData, setTableValues } = useAppContext()
    const [{ revenueDiff }] = chartsValues.slice(-1)
    const [{ totalROI }] = tableValues.slice(-1)

    const handleCopy = () => {
        const stringifyedCurrentWebsiteData = queryString.stringify(currentWebsiteFormData)
        const stringifyedNewWebsiteData = queryString.stringify(newWebsiteFormData)
        const stringifyedInvestmentFormData = queryString.stringify(investmentFormData)
        const querryString = `${stringifyedCurrentWebsiteData}|${stringifyedNewWebsiteData}|${stringifyedInvestmentFormData}|${monthsForChart}`
        navigator.clipboard.writeText(window.location.origin + '/' + querryString)
        setBtnText('Link copied')
        setTimeout(() => { setBtnText('Share results') }, 3000)
    }


    const changeMonthHandler = useCallback((e: ChangeEvent<HTMLSelectElement>) => {
        setmonthsForChart(Number(e.target.value))
        setTableValues(getTableValues(currentWebsiteFormData, newWebsiteFormData, investmentFormData, Number(e.target.value)))
    }, [setmonthsForChart, currentWebsiteFormData, newWebsiteFormData, investmentFormData, monthsForChart])

    return (
        <div className={styles.impact}>
            <div className={styles.impactWrapper}>
            <h3 className={styles.heading}>Impact</h3>
                <div className={styles.selectWrapper}>
                    <select className={styles.months} id="monthsForChart" name="monthsForChart" value={monthsForChart} onChange={changeMonthHandler}>
                        <option value={6}> 6 months</option>
                        <option value={12}> 12 months</option>
                        <option value={18}> 18 months</option>
                        <option value={24}> 24 months</option>
                        <option value={36}> 36 months</option>
                </select>
            </div>
            <h6>Return on Investment (ROI)</h6>
            <NumericFormat
                value={totalROI} displayType={'text'} thousandSeparator={true} suffix={'%'}
                renderText={(value) => <h4 className={revenueDiff > 0 ? styles.profit : styles.less}>{value}</h4>} />
            <h6>Net revenue difference</h6>
            <NumericFormat
                value={revenueDiff} displayType={'text'} thousandSeparator={true} prefix={'$'}
                renderText={(value) => <h4 className={revenueDiff > 0 ? styles.profit : styles.less}>{value}</h4>} />
                <button className={`${styles.share_btn} ${btnText === 'Share results' ? styles.mainBackgroundBtnColor : styles.hoverBackgroundBtnColor}`} onClick={handleCopy}>
                {btnText === 'Share results' ?
                    <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.750747 16.625C0.686476 16.634 0.621268 16.634 0.556997 16.625C0.426468 16.5826 0.313516 16.4985 0.235575 16.3855C0.157635 16.2725 0.11904 16.1371 0.125747 16V15.375C0.125994 12.5507 1.13284 9.819 2.96556 7.67013C4.79829 5.52125 7.3369 4.09594 10.1257 3.65V1C10.1257 0.88393 10.1581 0.770153 10.2191 0.671418C10.2801 0.572683 10.3674 0.492891 10.4712 0.440983C10.5751 0.389075 10.6913 0.367102 10.8069 0.377526C10.9225 0.387949 11.0329 0.430358 11.1257 0.5L18.6257 6.125C18.7034 6.18322 18.7664 6.25871 18.8098 6.34549C18.8532 6.43228 18.8757 6.52797 18.8757 6.625C18.8757 6.72203 18.8532 6.81772 18.8098 6.90451C18.7664 6.99129 18.7034 7.06678 18.6257 7.125L11.1257 12.75C11.0329 12.8196 10.9225 12.8621 10.8069 12.8725C10.6913 12.8829 10.5751 12.8609 10.4712 12.809C10.3674 12.7571 10.2801 12.6773 10.2191 12.5786C10.1581 12.4798 10.1257 12.3661 10.1257 12.25V9.90625C7.09927 10.4002 4.3891 12.0663 2.582 14.5437L1.257 16.3687C1.19881 16.4484 1.12261 16.5131 1.03463 16.5576C0.94664 16.6022 0.849363 16.6253 0.750747 16.625ZM11.3757 2.25V4.2C11.3767 4.35451 11.3204 4.50389 11.2176 4.61931C11.1149 4.73473 10.9731 4.80801 10.8195 4.825C8.46282 5.08211 6.25983 6.11998 4.56102 7.77349C2.86222 9.42699 1.76519 11.6011 1.4445 13.95L1.5445 13.8188C2.61404 12.3502 3.98116 11.1236 5.55669 10.219C7.13222 9.31436 8.88076 8.75206 10.6882 8.56875C10.7754 8.56064 10.8632 8.57091 10.9461 8.59891C11.029 8.6269 11.1051 8.67199 11.1695 8.73125C11.2342 8.78968 11.286 8.86102 11.3216 8.94067C11.3571 9.02033 11.3755 9.10654 11.3757 9.19375V11L17.207 6.625L11.3757 2.25Z" fill="#101820" />
                    </svg>
                    :
                    <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 7.5L5 11.5L15 1.5" stroke="#111C1F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>}
                <span>
                {btnText}
                </span>
            </button>
        </div>
        </div>
    )
}
